export default (fields) =>
  fields.map((field) => ({
    ...field,
    title: field.label.trim() || field?.options?.[0] || '',
  }));
